export default "__VITE_ASSET__DScN8AJm__"